import PageDescription from './page-description'

export default {
  state: {
  },
  getters: {
    createPageDescription: (state, {collectionsConfig}) => () => new PageDescription(collectionsConfig)
  }
}
